import { render, staticRenderFns } from "./RegisterNewUser.vue?vue&type=template&id=c3573db2"
import script from "./RegisterNewUser.vue?vue&type=script&lang=js"
export * from "./RegisterNewUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports